<template>
  <div class="mall-switch" @click="$emit('change', !value)">
    <img v-if="value" src="@/assets/mall/img_switch_on.svg" alt="켜짐" />
    <img v-else src="@/assets/mall/img_switch_off.svg" alt="꺼짐" />
  </div>
</template>

<script>
export default {
  name: 'MallSwitch',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.mall-switch {
  flex-shrink: 0;
  cursor: pointer;
}

.mall-switch img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallSwitch.vue